module.exports = __webpack_public_path__ + "static/media/15.f1e06591.png";